import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    paginationWrapper: {
        display: 'flex',
        margin: theme.spacing(3, 0),
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-end',
        },
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        }
    },
    title: {
        width: '100%',
        height: 'auto',
        padding: '0 7.5%',
        margin: '1% 0',
        [theme.breakpoints.down('769')]: {
            width: '90%',
        },
    },
    subtitle: {
        borderLeftColor: '#F5B750',
        borderLeftStyle: 'solid',
        borderLeftWidth: 7,
        fontSize: 26,
        color: '#344450',
        fontWeight: 'bold',
        padding: '2% 3%',
        margin: '1% 0',
        [theme.breakpoints.down('1100')]: {
            borderLeftWidth: 5,
            fontSize: 22,
        },
        [theme.breakpoints.down('769')]: {
            borderLeftWidth: 3,
            fontSize: 18,
        }
    },
    tab: {
        display: 'flex',
        width: '85%',
        margin: '0 auto',
        color: '#344450',
        backgroundColor: '#E4E4E4',
        [theme.breakpoints.down('769')]: {
            width: '100%'
        }
    },
    item: {
        width: 'auto',
        padding: '15px 0',
        cursor: 'pointer',
        textAlign: 'center',
        minWidth: `${100 / 3}%`,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
            padding: '14px 0',
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
            padding: '12px 0',
        },
        [theme.breakpoints.down('400')]: {
            fontSize: 10,
            padding: '10px 0',
        }
    },
    itemSelected: {
        color: 'white',
        backgroundColor: '#344450'
    },
    // container: {
    //     width: '85%',
    //     height: 'auto',
    //     minHeight: 300,
    //     marginBottom: '3%',
    //     backgroundColor: '#F2F3F2',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     margin: '0 auto',
    //     [theme.breakpoints.down('769')]: {
    //         width: '100%'
    //     }
    // },
    // containerContent: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     flexWrap: 'wrap',
    //     width: '85%',
    //     [theme.breakpoints.down('1100')]: {
    //         width: '95',
    //     },
    //     [theme.breakpoints.down('750')]: {
    //         width: '100%',
    //     },
    //     margin: '0 auto'
    // },
    trainingsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        [theme.breakpoints.down('1150')]: {
            justifyContent: 'space-around'
        },
    },
    trainingBox: {
        height: 'auto',
        marginBottom: 10,
        cursor: 'pointer',
        width: '49%',
        backgroundColor: 'white',
        padding: 10,
        minWidth: 400,
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('1150')]: {
            width: '70%',
        },
        [theme.breakpoints.down('750')]: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 200,
            width: '90%',
        },
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid #E4E4E4'
    },
    trainingTitle: {
        fontSize: 18,
        margin: 'auto',
        color: '#344450',
        fontWeight: 'bold',
        [theme.breakpoints.down('769')]: {
            fontSize: 16
        }
    },
    trainingDateBoxed: {
        padding: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        // alignContent:'center',
        color: '#FFFFFF',
        backgroundColor: '#F5B750',
        fontSize: 12,
    },
    trainingDate: {
        color: '#344450',
        fontSize: 14,
        fontWeight: '500',
        paddingTop: 10,
    },
    // trainingPic: {
    //     height: 'auto',
    //     minWidth: 200,
    //     display: 'block',
    //     width: '50%',
    //     [theme.breakpoints.down('750')]: {
    //         width: 'auto',
    //     },
    // },
    interactionsSummary: {
        color: '#344450',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    interactionsCount: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginTop: 10,
        [theme.breakpoints.down('750')]: {
            marginTop: 7
        },
    },
    // trainingInfo: {
    //     height: 200,
    //     width: '50%',
    //     paddingLeft: 7,
    //     paddingRight: 7,
    //     paddingTop: 20,
    //     paddingBottom: 10,
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: 'space-between',
    //     alignItems: 'center',
    //     [theme.breakpoints.down('750')]: {
    //         width: '100%',
    //         height: 'auto',
    //     },
    // },
  
    banner: {
        width: '85%',
        height: 'auto',
        margin: '1% auto',
        marginBottom: '4%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backdropFilter: 'blur(10px)',
        zIndex: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end'
    },
    bannerButton: {
        width: 'auto',
        backgroundColor: '#F5B750',
        border: '2px solid #FFFFFF',
        cursor: 'pointer',
        position: 'absolute',
        zIndex: 2,
        margin: '10% 10%',
    },
    buttonText: {
        width: 150,
        width: 'fit-content',
        color: '#FFFFFF',
        fontSize: 20,
        padding: 12,
        fontWeight: 'bold',
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
            padding: 10,
        },
        [theme.breakpoints.down('768')]: {
            fontSize: 14,
            padding: 10,
        },
    },
    root: {
        '& .MuiInput-underline:after': {
            borderColor: '#F5B750',
            borderRadius: 0
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'transparent'
            },
            '&:hover fieldset': {
                borderColor: 'transparent'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#F5B750',
                borderRadius: 0
            },
            '&.Mui-focused .MuiInputAdornment-root .MuiSvgIcon-root': {
                color: '#F5B750'
            },
        },
        backgroundColor: '#FFFFFF',
        margin: 'auto',
        marginTop: 20,
        marginBottom: 20,
        [theme.breakpoints.down('769')]: {
            marginTop: 10,
            marginBottom: 10,
        },
        width: '100%',
        [theme.breakpoints.down('600')]: {
            width: '90%',
        }
    },
    multilineColor: {
        color: '#344450',
        fontSize: 16,
        [theme.breakpoints.down('1100')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 12,
            height: 30
        },
    },
    trainingBanner: {
        margin: '0 auto',
        height: 'auto',
        width: 500,
        [theme.breakpoints.down('768')]: {
            width: 200
        },
    }
}))

export default useStyles